import React, { useEffect } from "react";
import RecipeCard from "./layouts/RecipeCard";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useSelector, useDispatch } from "react-redux";
import { getReceipes } from "../store/actions/receipeActions";
import Loader from "./layouts/Loader";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    padding: "0 30px",
  },
}));

const Recipe = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const receipe = useSelector((state) => state.receipe);
  const { login, todaysRecipes, loading, error, filter } = receipe;
  useEffect(() => {
    dispatch(getReceipes());

    // eslint-disable-next-line
  }, []);

  const getData = () => (filter.length !== 0 ? filter : todaysRecipes);
  return !loading && !error && todaysRecipes?.length !== 0 ? (
    <div className={classes.root}>
      {!filter?.length && (
        <h2 className={classes.heading}>Todays Recipe For You</h2>
      )}
      <Grid className={classes.grid} container spacing={3}>
        {todaysRecipes?.length !== 0 ? (
          getData().map((doc) => (
            <RecipeCard
              key={doc.id}
              login={login}
              id={doc.id}
              receipes={doc.data}
            />
          ))
        ) : (
          <h6 style={{ margin: "0 auto" }}>No receipe</h6>
        )}
      </Grid>
    </div>
  ) : (
    <Loader />
  );
};

export default Recipe;
